module.exports = __webpack_public_path__ + "static/media/endorsement.c514932f.svg";